import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Form, { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import Select from '@atlaskit/select';
import { DatePicker } from '@atlaskit/datetime-picker';
import { useTranslation } from "react-i18next";
import useFetch from '../../../../../../hooks/use-fetch';

import ErrorsBlock from '../../../../../../components/errors';

const GroupForm = ({currentItem, onChangeItem, closeModal, open}) => {
  const {t} = useTranslation();
  const [position, setPosition] = useState(currentItem.attributes.position);
  const [inEquipmentId, setInEquipmentId] = useState("");
  const [equipmentList, setEquipmentList] = useState([{label: t('no_related_equipment'), value: ""}]);
  const [errors, setErrors] = useState([]);

  const [{response: equipmentResponse, isLoading: equipmentIsLoading, error: equipmentError}, doFetchEquipment] = useFetch(`/directories/equipment_items`);
  const [{response: saveResponse, isLoading: saveIsLoading, error: saveError}, doFetchItemSave] = useFetch(`/directories/equipment_items/${currentItem.id}/changes`);

  useEffect(() => {
    doFetchEquipment()
  }, [])

  useEffect(() => {
    if(currentItem.attributes.parent_id === null) {
      return;
    }
    setInEquipmentId(currentItem.attributes.parent_id);
  },[]);

  useEffect(() => {
    if(!equipmentResponse) {
      return;
    }
    let list = []
    equipmentResponse.data.map(eq => {
      list.push({label: eq.attributes.name, value: eq.id})
    })
    setEquipmentList([...equipmentList, ...list])
  },[equipmentResponse])


  useEffect(() => {
    if(!saveResponse) {
      return
    }
    closeModal()
  },[saveResponse])

  const handleUpdate = (data) => {
    let date = new Date()
    onChangeItem({...currentItem, attributes: {...currentItem.attributes, parent_id: data.parent.value, position: data.position, parent_changed_at: date}})
    doFetchItemSave({
      method: 'POST',
      data: {
        data: {
          parent_id: data.parent.value ? Number(data.parent.value) : null,
          position: data.position ? Number(data.position) : null,
          at: date
        }
      }
    });
  };

  return (
    <Transition appear show={open} as={Fragment}>
    <Dialog
      as="div"
      className="fixed inset-0 z-50 overflow-y-auto"
      onClose={closeModal}
    >
      <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
      <div className="min-h-screen px-4 text-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="inline-block w-full max-w-md p-6 mt-32 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded">
            <Dialog.Title
              as="h3"
              className="text-lg font-medium leading-6 text-gray-900"
            >
              {t('change_parent')}
            </Dialog.Title>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {t('change_parent_form_text')}
              </p>
            </div>
            {errors.length > 0 ? <ErrorsBlock errors={errors}/> : ''}
            <Form onSubmit={data => handleUpdate(data)}>
              {({ formProps }) => (
                <form {...formProps} className="text-sm">
                  <div className="text-sm">
                    <Field name="parent" label={t('in_parent_equipment')} 
                      defaultValue={equipmentList.find(i => i.value == inEquipmentId)}
                    >
                      {({ fieldProps, error, meta: { valid } }) => 
                        <Select {...fieldProps} options={equipmentList} placeholder={t('enter_and_select_placeholder')} className="text-sm"/>
                      }
                    </Field>
                    <Field name="position" label={t('in_parent_equipment_position')} defaultValue={position || ""}>
                      {({ fieldProps, error, meta: { valid } }) => 
                        <TextField {...fieldProps} type="number" placeholder={t('select_placeholder')} className="text-sm"/>
                      }
                    </Field>
                  </div>
                  <div className="flex justify-between mt-8">
                    <button 
                      onClick={() => closeModal()}
                      type="button" 
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-900 bg-gray-100 border border-transparent rounded hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    >
                      {t('cancel')}
                    </button>
                    <button 
                      // onClick={() => handleUpdate()}
                      type="submit" 
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    >
                      {t('save')}
                    </button>

                  </div>
                </form>
              )}
            </Form>
          </div>
        </Transition.Child>
      </div>
      
    </Dialog>
  </Transition>
  )
}

export default GroupForm;